import { setupCache } from 'axios-cache-adapter';

// eslint-disable-next-line prefer-regex-literals
const AXIOS_CACHE_ALLOWLIST_REGEX = new RegExp(
  '/account/v./profile$|/business.service/v./businesses/outlets$'
);
// eslint-disable-next-line prefer-regex-literals
const AXIOS_CACHE_INVALIDATELIST_REGEX = new RegExp(
  `/account/v./user/settings$|/api/v./login/outlets|/api/v./outlets|/api/v./businesses/|/business.service/v./businesses/outlets|/business.service/v./businesses/info|/partner/v./partners/./outlets/./token`
);
const AXIOS_CACHE_MAXAGE_MS = 5 * 60 * 1000; // 5 minutes

function setupAxiosCache(allowListRegexp, invalidateListRegexp, maxAgeMs) {
  return setupCache({
    maxAge: maxAgeMs,
    readHeaders: false,
    exclude: {
      filter: (request) => !allowListRegexp.test(request.url),
      query: false,
    },
    invalidate: async (config, request) => {
      if (
        (request?.method?.toLowerCase() !== 'get' &&
          invalidateListRegexp.test(request.url)) ||
        (request.params !== undefined && request.params.refresh)
      ) {
        await (config.store as any).clear();
      }
    },

    // Read stale cache data on network error
    readOnError: (error) => {
      return error.response.status >= 500 && error.response.status < 600;
    },
    clearOnStale: false,

    debug: process.env.NODE_ENV !== 'production',
  });
}

const axiosCacheInstance = setupAxiosCache(
  AXIOS_CACHE_ALLOWLIST_REGEX,
  AXIOS_CACHE_INVALIDATELIST_REGEX,
  AXIOS_CACHE_MAXAGE_MS
);

export { setupAxiosCache };

export default axiosCacheInstance;
